import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { RegistrationFacade } from 'src/app/store/registration/facade/registration.facade';

@Component({
  selector: 'app-save-failed',
  templateUrl: './save-failed.component.html',
  styleUrls: ['./save-failed.component.scss']
})
export class SaveFailedComponent implements OnInit, OnDestroy {

  dialogAfterOpenSubscription: Subscription;
  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SaveFailedComponent>) { }

  ngOnInit() {
  }

  ngOnDestroy() {
  }
  public closeDialog() {
    this.dialogRef.close();
  }

}
